import {API} from "./API";
import * as moment from 'moment'

export class ReportsAPI extends API<null> {

	constructor () {
		super("users");
	}


	invoicesAndPaymentsPerPeriod () {
		const url = `/reports/payments_and_invoices`;
		return API.axiosInstance.get(url);
	}

	servicesPerPeriod (fromDate: Date, toDate: Date) {
		let from = moment(fromDate).format('YYYY-MM-DD')
		let to = moment(toDate).format('YYYY-MM-DD')
		const url = `/reports/services?from=${from}&to=${to}`;
		return API.axiosInstance.get(url);
	}
}
